import React from 'react';

const SectionSeparator = ({ className = '' }) => {
  return (
    <div className={`w-full flex justify-center py-8 ${className}`}>
      <img
        src="https://customer-assets.emergentagent.com/job_sragcorp/artifacts/f8m9iahf_SRAGlogo-line.png"
        alt=""
        className="h-12 md:h-16 w-auto object-contain opacity-80"
      />
    </div>
  );
};

export default SectionSeparator;
